import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { BulletIcon } from '@koaly/koaly-ui-icons';
import { rem, marginBottomSpacing, spaceProp, getVariantToken, getColorToken } from '@koaly/mixins';
import React from 'react';
import styled, { css } from 'styled-components';

const ContainerCSS = css `
  ${({ theme }) => `max-width: ${theme.tokens.containerMaxWidth}`};
  /* box-sizing: border-box; */
  margin: 0 auto;
  padding-left: ${rem(20)};
  padding-right: ${rem(20)};
`;
const StyledContainer = styled.div `
  ${ContainerCSS};
  position: relative;
  z-index: 2;
`;
const StyledBackground = styled.div `
  ${({ spaceAfter }) => spaceAfter && marginBottomSpacing(spaceAfter)};
  ${({ spacing }) => spacing && spaceProp(spacing, 'padding')};
  ${({ backgroundFigures }) => backgroundFigures &&
    `
    overflow: hidden;
    position: relative;
  `};
  ${({ background, variant, backgroundSwitchPercentage, backgroundSwitchVariant }) => background &&
    ((backgroundSwitchVariant && backgroundSwitchPercentage) ?
        css `
      background: linear-gradient(
        to bottom,
        ${getVariantToken('container', 'backgroundColor', variant)},
        ${getVariantToken('container', 'backgroundColor', variant)} ${backgroundSwitchPercentage}%,
        ${getVariantToken('container', 'backgroundColor', backgroundSwitchVariant)} ${backgroundSwitchPercentage}%
      );
    ` :
        css `
      background: ${getVariantToken('container', 'backgroundColor', variant)};
    `)};
  ${({ fadeOut }) => fadeOut && 'background-image: linear-gradient(180deg, rgba(255, 255, 255, 0) 71.35%, #ffffff 100%);'}
`;
const StyledBackgroundEar = styled(BulletIcon) `
  position: absolute;
  transform: rotate(-75deg);
  left: calc(100% - 20%);
  top: -470px;
  path {
    fill: ${getColorToken('400', 'primary')};
  }
`;
const StyledBackgroundEarTwo = styled(BulletIcon) `
  position: absolute;
  transform: rotate(200deg);
  right: calc(100% - 380px);
  bottom: -740px;
  path {
    fill: ${getColorToken('100', 'primary')};
  }
`;
const Container = (_a) => {
    var { children, backgroundFigures } = _a, other = __rest(_a, ["children", "backgroundFigures"]);
    return (React.createElement(StyledBackground, Object.assign({ backgroundFigures: backgroundFigures }, other),
        React.createElement(StyledContainer, null, children),
        backgroundFigures && React.createElement(StyledBackgroundEar, { width: "930", height: "917" }),
        backgroundFigures && React.createElement(StyledBackgroundEarTwo, { width: "930", height: "917" })));
};
Container.defaultProps = {
    background: false,
};

export { Container, ContainerCSS };
//# sourceMappingURL=Container.js.map
